var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,staticStyle:{"width":"100%","margin":"20px auto"},attrs:{"scale":"page-width","src":_vm.sysDoc,"page":i}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85312ff2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocationView.vue
// module id = null
// module chunks = 